import React from "react";
import useReveal from "../../hooks/useReveal";

const HookSection = () => {
  useReveal();
  return (
    <section
      id="gancho"
      data-testid="section-gancho"
      className="bdk-section"
      style={{ background: "var(--ink)", color: "#fff" }}
    >
      <div className="container-bdk grid lg:grid-cols-[1.1fr_.9fr] gap-16 items-center">
        <div
          className="bdk-reveal bdk-reveal--left"
          style={{ "--reveal-delay": "0ms" }}
        >
          <p className="kicker">Diferenciador</p>
          <h2 className="font-display text-[38px] sm:text-[48px] md:text-[56px] lg:text-[64px]">
            Primero la ves.
            <br />
            Luego decides.
          </h2>
          <p className="mt-5 text-[#b9bac3] text-[15px] md:text-[16px] max-w-[560px]">
            Sabemos que hay muchas opciones vendiendo páginas web. Por eso, para
            landing pages y páginas sencillas, podemos prepararte una propuesta
            visual inicial antes de cerrar trato.
          </p>

          <div
            className="mt-6 p-5 md:p-6 rounded-[10px]"
            style={{
              borderLeft: "4px solid var(--red)",
              background: "var(--ink-2)",
            }}
          >
            <p className="text-[15px] md:text-[16px] font-semibold leading-relaxed text-white">
              Ves una idea de cómo podría lucir tu página.
              <br />
              Si te gusta el estilo y el enfoque, avanzamos.
              <br />
              Si no, no hay compromiso.
            </p>
          </div>

          <p className="mt-6 text-[12px] text-[#b9bac3]">
            <span className="text-[#d90020] font-bold">Importante:</span>{" "}
            Aplica únicamente para landing pages y sitios informativos sencillos.
            No aplica para sistemas web, ecommerce, bases de datos, paneles
            administrativos ni desarrollos a la medida.
          </p>

          <a
            href="#contacto"
            data-testid="gancho-cta"
            onClick={() => window.fbq?.("trackCustom", "ClickPropuestaVisual")}
            className="bdk-btn bdk-btn--primary bdk-btn--lg mt-7"
          >
            Solicitar mi propuesta
          </a>
        </div>

        <div
          className="grid grid-cols-2 gap-3 bdk-reveal bdk-reveal--right"
          style={{ "--reveal-delay": "0ms" }}
        >
          {[
            {
              n: "01",
              t: "Nos cuentas de tu negocio",
              d: "Qué vendes, a quién y qué necesitas lograr con tu página.",
            },
            {
              n: "02",
              t: "Revisamos qué necesitas",
              d: "Identificamos si tu proyecto es elegible para propuesta visual.",
            },
            {
              n: "03",
              t: "Preparamos tu propuesta",
              d: "Para páginas sencillas elegibles, una idea visual inicial.",
            },
            {
              n: "04",
              t: "Si te convence, avanzamos",
              d: "Sin compromiso si el enfoque no es lo que buscabas.",
            },
          ].map((s, i) => (
            <article
              key={s.n}
              data-testid={`gancho-step-${i}`}
              className="p-6 rounded-[12px]"
              style={{
                background: "var(--ink-2)",
                border: "1px solid #34353e",
              }}
            >
              <span className="font-display text-[50px] font-black text-[#d90020] leading-none block">
                {s.n}
              </span>
              <h3 className="font-display text-[22px] mt-2">{s.t}</h3>
              <p className="mt-1 text-[#b8b9c1] text-[12px]">{s.d}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HookSection;
